/**
 * HE.Web.POIMap
 */

(function POIMap($, HE)
{
	"use strict";

	var poimap = function POIMap()
	{
		var self = this;

		try
		{
			if ((this instanceof POIMap) === false) {
				return new POIMap();
			}

			if (typeof google.maps !== 'object') {
				throw new Error('Google Maps library is not loaded!');
			}

			this.$map        = $('#poi-map-container #poi-map');
			this.main_marker = null;
			this.map         = new HE.Map(this.$map, {
				zoom: 15,
				init: function map_init(map) {
					if (self.$map.data('main-marker').lat) {
						self.main_marker = self.$map.data('main-marker');
						map.populate([self.main_marker]);
					}
				}
			});

			// add/remove points-of-interest map markers individually
			// per-poi, in order to selectively have a mix of categories
			$('#poi-map-container .poi-map-category').click(function plotPOICategoryMarkers()
			{
				var that = this;

				$(that).data('markers').forEach(function _plotPOICategoryLocationMarker(marker) {
					if (that.checked) {
						// differentiate the icon from the main_marker (hotel)
						// official markers: http://kml4earth.appspot.com/icons.html
						marker.icon = 'https://maps.google.com/mapfiles/kml/paddle/red-stars-lv.png';
						self.map._createMarker(marker);
					} else {
						self.map._destroyMarker(marker);
					}
				});

				self.map.viewAllMarkers();

				if (self.map.mapMarkers.length === 1) {
					self.map.map.setZoom(15);
				}
			});
		}
		catch (err)
		{
			console.error('[HE.POIMap]', err);
		}
	};

	poimap.prototype.setMainMarker = function setMainMarker(marker)
	{
		this.map._destroyMarker(this.main_marker);
		this.main_marker = marker;
		this.map._createMarker(this.main_marker);

		// preserve the last view so all selected POIs stay put
		this.map.viewAllMarkers();
		if (this.map.mapMarkers.length === 1) {
			this.map.map.setZoom(15);
		}
	};

	HE.Web.POIMap = poimap;
}(jQuery, window.HE || {}));